import React from 'react';

import { MenuItem } from '@mui/material';
import produce from 'immer';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import Icon from 'components/common/Icons/base/Icon/Icon';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { Button } from 'components/DesignSystem/Button';
import { CustomizedDropdownMenu, CustomizedTooltip } from 'components/common';

import classes from './customizeFilter.module.scss';

const CustomizeFilter = ({ ui, logic }) => {
    const handleSelection = (value) => {
        if (ui.state.customizeFilterOptions[value].isSelected) {
            if (
                value === 'hasComments' ||
                value === 'startDate' ||
                value === 'baselineStartDate' ||
                value === 'baselineEndDate'
            ) {
                const flags = { ...ui.form.watch('flags') };
                value === 'hasComments' && delete flags.commentRange;
                value === 'startDate' && delete flags.startDatesRange;
                value === 'baselineStartDate' && delete flags.baselineStartDatesRange;
                value === 'baselineEndDate' && delete flags.baselineEndDatesRange;
                ui.form.setValue('flags', flags);
                ui.form.setValue(value, { value: [], type: 'TODAY_REF' });
            } else {
                ui.form.setValue(value, null);
            }

            ui.form.handleSubmit(logic.onFiltersChanged)();
        }

        ui.setters.setCustomizeFilterOptions(
            produce(ui.state.customizeFilterOptions, (draft) => {
                draft[value].isSelected = !draft[value].isSelected;
                return draft;
            }),
        );
    };

    return (
        <div data-testid={'more-filters-button'}>
            <CustomizedDropdownMenu
                triggerElement={
                    <CustomizedTooltip
                        tooltipPosition={TooltipPosition.Top}
                        tooltipContent={`More Filters`}
                        triggerElement={
                            <Button
                                endIcon={
                                    <Icon
                                        name={'header-arrow-down'}
                                        size={'15px'}
                                        color={'var(--button-secondary-fg)'}
                                    />
                                }
                                startIcon={
                                    <MuiIcon
                                        icon={'more_horiz'}
                                        fontSize={'15px'}
                                        color={'var(--button-secondary-fg)'}
                                    />
                                }
                                variant={'secondary'}
                            >
                                More Filters
                            </Button>
                        }
                    />
                }
                closeDropdownOnItemClick={false}
            >
                {Object.entries(ui.state.customizeFilterOptions).map(([key, item]) => (
                    <MenuItem key={key} onClick={() => handleSelection(key)}>
                        <div className={classes.customizeFilterContainerRow}>
                            <span>{item.label}</span>
                            {item.isSelected ? (
                                <span className={classes.remove}>
                                    <Icon name={'filter-x-icon'} size={'2rem'} color={'#cccccc'} /> <span>Remove</span>
                                </span>
                            ) : (
                                <span className={classes.add}>
                                    <Icon name={'Governance-top-right-tick'} size={'1.3rem'} color={'#cccccc'} />{' '}
                                    <span>Add</span>
                                </span>
                            )}
                        </div>
                    </MenuItem>
                ))}
            </CustomizedDropdownMenu>
        </div>
    );
};

export default React.memo(CustomizeFilter);
